import { css, keyframes, styled } from 'styled-components'; 
import { CampaignStatus } from '@/types/campaign/campaign-status/campaign-status';
import { DefaultTheme } from 'styled-components';

const getStatusColor = (status: CampaignStatus) => {
    switch (status) {
        case 'pending_claim':
            return (props: { theme: DefaultTheme }) => props.theme?.colors?.common?.yellow; 
        case 'completed':
            return (props: { theme: DefaultTheme }) => props.theme?.colors?.theme?.success;
        case 'expired':
            return (props: { theme: DefaultTheme }) => props.theme?.colors?.text?.muted;
        case 'inCourse':
            return (props: { theme: DefaultTheme }) => props.theme?.colors?.theme?.success;
        case 'comingUp':
            return (props: { theme: DefaultTheme }) => props.theme?.colors?.theme?.warning;
        default:
            return (props: { theme: DefaultTheme }) => props.theme?.colors?.theme?.success;
    }
};

export const TimeContainer = styled.div`
    display: flex;
    align-items: center;
    gap: var(--Sizes---sise-s, 8px);
`;

export const TimeWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const IconWrapper = styled.div<{ $status: CampaignStatus }>`
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => 
        (props.$status === 'inCourse' || props.$status === 'incourseWinning' || props.$status === 'incourseLoosing')
        ? ({ theme }) => theme?.colors?.common?.green
        : getStatusColor(props.$status)};

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        filter: ${props => props.$status === 'expired' ? 'opacity(0.5)' : 'none'};
    }
`;

export const TextInfo = styled.span<{ $status?: CampaignStatus; $isTime?: boolean }>`
    font-family: "Red Hat Display", sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.4px;
    color: ${props => {
        if (props.$isTime) {
            return props.theme.colors.text.headings;
        }
        if (props.$status === 'inCourse' || props.$status === 'incourseWinning' || props.$status === 'incourseLoosing') {
            return props.theme.colors.common.green;
        }
        return props.$status ? getStatusColor(props.$status) : props.theme.colors.text.headings;
    }};
`;

export const StartDateTextInfo = styled(TextInfo)`
    color: ${({ theme }) => theme?.colors?.theme?.warning};
`;

export const StatusChip = styled.div<{ $status: CampaignStatus }>`
    padding: 0px;
    border-radius: 16px;
    font-family: 'Red Hat Display', sans-serif;
    font-size: 12px;
    font-weight: 600;

    color: ${props => getStatusColor(props.$status)};
`;

const pulseAnimation = keyframes`
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.7);
    }
    
    70% {
        transform: scale(1);
        box-shadow: 0 0 0 4px transparent;
    }
    
    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 transparent;
    }
`;

export const StatusDot = styled.div<{ $status: CampaignStatus }>`
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: ${props => getStatusColor(props.$status)};
    animation: ${props => (props.$status === 'inCourse' || props.$status === 'incourseWinning' || props.$status === 'incourseLoosing') && css`${pulseAnimation} 2s infinite`};
`;